"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _EdelmetallItem = _interopRequireDefault(require("./EdelmetallItem"));
var _Kunde = _interopRequireDefault(require("./Kunde"));
var _Lieferadresse = _interopRequireDefault(require("./Lieferadresse"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The BackendPdfRequest model module.
 * @module model/BackendPdfRequest
 * @version 1.0.44
 */
var BackendPdfRequest = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>BackendPdfRequest</code>.
   * Alle nötigen Informationen für das Pdf zu einer Bestellung
   * @alias module:model/BackendPdfRequest
   * @param date {String} Datum der Bestellung
   * @param customer {module:model/Kunde} 
   * @param item {module:model/EdelmetallItem} 
   * @param mitarbeiter {String} Zuständiger Mitarbeiter für die Bestellung
   * @param filiale {String} Name der Zuständigen Filiale
   * @param id {Number} ID der Bestellung
   * @param deliveryAddress {module:model/Lieferadresse} 
   * @param deliveryDate {String} Lieferdatum
   */
  function BackendPdfRequest(date, customer, item, mitarbeiter, filiale, id, deliveryAddress, deliveryDate) {
    _classCallCheck(this, BackendPdfRequest);
    BackendPdfRequest.initialize(this, date, customer, item, mitarbeiter, filiale, id, deliveryAddress, deliveryDate);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(BackendPdfRequest, null, [{
    key: "initialize",
    value: function initialize(obj, date, customer, item, mitarbeiter, filiale, id, deliveryAddress, deliveryDate) {
      obj['date'] = date;
      obj['customer'] = customer;
      obj['item'] = item;
      obj['mitarbeiter'] = mitarbeiter;
      obj['filiale'] = filiale;
      obj['id'] = id;
      obj['deliveryAddress'] = deliveryAddress;
      obj['deliveryDate'] = deliveryDate;
    }

    /**
     * Constructs a <code>BackendPdfRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BackendPdfRequest} obj Optional instance to populate.
     * @return {module:model/BackendPdfRequest} The populated <code>BackendPdfRequest</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new BackendPdfRequest();
        if (data.hasOwnProperty('date')) {
          obj['date'] = _ApiClient.default.convertToType(data['date'], 'String');
        }
        if (data.hasOwnProperty('customer')) {
          obj['customer'] = _Kunde.default.constructFromObject(data['customer']);
        }
        if (data.hasOwnProperty('item')) {
          obj['item'] = _EdelmetallItem.default.constructFromObject(data['item']);
        }
        if (data.hasOwnProperty('mitarbeiter')) {
          obj['mitarbeiter'] = _ApiClient.default.convertToType(data['mitarbeiter'], 'String');
        }
        if (data.hasOwnProperty('filiale')) {
          obj['filiale'] = _ApiClient.default.convertToType(data['filiale'], 'String');
        }
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient.default.convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('deliveryAddress')) {
          obj['deliveryAddress'] = _Lieferadresse.default.constructFromObject(data['deliveryAddress']);
        }
        if (data.hasOwnProperty('deliveryDate')) {
          obj['deliveryDate'] = _ApiClient.default.convertToType(data['deliveryDate'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>BackendPdfRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>BackendPdfRequest</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(BackendPdfRequest.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // ensure the json data is a string
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['date'] && !(typeof data['date'] === 'string' || data['date'] instanceof String)) {
        throw new Error("Expected the field `date` to be a primitive type in the JSON string but got " + data['date']);
      }
      // validate the optional field `customer`
      if (data['customer']) {
        // data not null
        _Kunde.default.validateJSON(data['customer']);
      }
      // validate the optional field `item`
      if (data['item']) {
        // data not null
        _EdelmetallItem.default.validateJSON(data['item']);
      }
      // ensure the json data is a string
      if (data['mitarbeiter'] && !(typeof data['mitarbeiter'] === 'string' || data['mitarbeiter'] instanceof String)) {
        throw new Error("Expected the field `mitarbeiter` to be a primitive type in the JSON string but got " + data['mitarbeiter']);
      }
      // ensure the json data is a string
      if (data['filiale'] && !(typeof data['filiale'] === 'string' || data['filiale'] instanceof String)) {
        throw new Error("Expected the field `filiale` to be a primitive type in the JSON string but got " + data['filiale']);
      }
      // validate the optional field `deliveryAddress`
      if (data['deliveryAddress']) {
        // data not null
        _Lieferadresse.default.validateJSON(data['deliveryAddress']);
      }
      // ensure the json data is a string
      if (data['deliveryDate'] && !(typeof data['deliveryDate'] === 'string' || data['deliveryDate'] instanceof String)) {
        throw new Error("Expected the field `deliveryDate` to be a primitive type in the JSON string but got " + data['deliveryDate']);
      }
      return true;
    }
  }]);
}();
BackendPdfRequest.RequiredProperties = ["date", "customer", "item", "mitarbeiter", "filiale", "id", "deliveryAddress", "deliveryDate"];

/**
 * Datum der Bestellung
 * @member {String} date
 */
BackendPdfRequest.prototype['date'] = undefined;

/**
 * @member {module:model/Kunde} customer
 */
BackendPdfRequest.prototype['customer'] = undefined;

/**
 * @member {module:model/EdelmetallItem} item
 */
BackendPdfRequest.prototype['item'] = undefined;

/**
 * Zuständiger Mitarbeiter für die Bestellung
 * @member {String} mitarbeiter
 */
BackendPdfRequest.prototype['mitarbeiter'] = undefined;

/**
 * Name der Zuständigen Filiale
 * @member {String} filiale
 */
BackendPdfRequest.prototype['filiale'] = undefined;

/**
 * ID der Bestellung
 * @member {Number} id
 */
BackendPdfRequest.prototype['id'] = undefined;

/**
 * @member {module:model/Lieferadresse} deliveryAddress
 */
BackendPdfRequest.prototype['deliveryAddress'] = undefined;

/**
 * Lieferdatum
 * @member {String} deliveryDate
 */
BackendPdfRequest.prototype['deliveryDate'] = undefined;
var _default = exports.default = BackendPdfRequest;